<template>
    <div class="fill-height of-y d-flex flex-column">

        <div class="d-flex align-center justify-center fill-height flex-column" v-if="loadingReport && !data.length">
            <loader :size="60"></loader>
        </div>

        <template v-else>
            <div class="flex-grow-0 pa-2 d-flex justify-space-between">
                <div class="flex-grow-1"></div>
                <div style="width: 30%">
                    <v-text-field
                            v-model="search"
                            prepend-icon="mdi-magnify"
                            label="Search Emp Code"
                            single-line
                            hide-details
                            class="pa-0 ma-0"
                            clearable
                    ></v-text-field>
                </div>
            </div>
            <div class="flex-grow-1 of-y">
                <v-data-table
                        dense
                        height="calc(100% - 80px)"
                        class="fill-height of-y"
                        :headers="headers"
                        :items="data"
                        :server-items-length="totalItems"
                        :options.sync="tableOptions"
                        :loading="loadingReport"
                        :footer-props="{ 'items-per-page-options': [25, 50, 100] }"
                ></v-data-table>
            </div>
        </template>

    </div>
</template>

<script>

import {mapGetters} from "vuex";
import Loader from "../General/Loader/Loader";

export default {
    components: {Loader},
    props: {
        selectedFarm: Number,
        selectedDate: Date
    },
    data() {
        return {
            search: '',
            searchTimeout: null,
            headers: [
                {text: "Emp Name", value: "empName", sortable: false},
                {text: "Emp Code", value: "empCode", sortable: false},
                {text: "Farm", value: "farm", sortable: false},
                {text: "Moved At", value: "movedAtStr", sortable: false},
                {text: "Moved By", value: "movedBy", sortable: false},
            ],
            data: [],
            totalItems: 0,
            tableOptions: {
                page: 1,
                itemsPerPage: 50
            },
            loadingReport: false,
        }
    },
    watch: {
        selectedFarm() {
            this.tableOptions.page = 1
            this.getReportData()
        },
        search() {
            clearTimeout(this.searchTimeout)
            this.searchTimeout = setTimeout(() => {
                this.tableOptions.page = 1
                this.getReportData()
            }, 300)
        },
        tableOptions: {
            deep: true,
            handler() {
                this.getReportData()
            }
        }
    },
    mounted() {
        this.getReportData()
    },
    methods: {
        async getReportData() {
            try {
                this.loadingReport = true;
                const result = await this.$newReq('POST', `reports/farmAudit`, {
                    farms: this.selectedFarm ? [this.selectedFarm] : this.availableFarmIDs,
                    page: this.tableOptions.page,
                    pageSize: this.tableOptions.itemsPerPage,
                    search: this.search || ''
                })
                this.data = result.rows
                this.totalItems = result.totalItems
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.loadingReport = false
            }
        },
    },
    computed: {
        ...mapGetters(['availableFarmIDs']),
    },
}
</script>

<style scoped>

</style>
